import { type SelectOption } from '../../../../../components';
import { ProgrammeTypes } from '../../../constants';
import { PAGE_TEXT } from '../../lang';

const programmeTypeText = PAGE_TEXT.GSB1_FORM.PROGRAMME_TYPE;
const programmeTypeKeys: string[] = Object.keys(programmeTypeText);

export const programmeOptions: SelectOption[] = Object.values(
  programmeTypeText,
).map((label: string, index: number) => ({
  value:
    ProgrammeTypes[programmeTypeKeys[index] as keyof typeof ProgrammeTypes],
  label,
}));
